import webpack from 'webpack';

export default () => (
  new webpack.ProvidePlugin({
    $: 'jquery',
    jQuery: 'jquery',
    Popper: 'popper.js',
  })
);
